










































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class DataTableWithDialog extends Vue {
  @Prop(Array) readonly items: any[] | undefined;

  @Prop(Array) readonly headers: any[] | undefined;

  @Prop(String) readonly itemKey: string | undefined;

  @Prop(String) readonly scope: string | undefined;

  @Prop(Boolean) readonly showAddButton: boolean | undefined;

  // eslint-disable-next-line class-methods-use-this
  data() {
    return {
      dialog: false,
      itemData: {},
      editingItem: null,
    };
  }

  get allHeaders() {
    return [...this.$props.headers, { text: '', value: 'actions', sortable: false }];
  }

  get dialogTitle() {
    if (this.$data.editingItem !== null) {
      return this.$t(`${this.scope}.updateDialog.title`);
    }
    return this.$t(`${this.scope}.addDialog.title`);
  }

  closeDialog() {
    this.$data.dialog = false;
    this.$data.editingItem = null;
  }

  openAddItemDialog() {
    const data = this.$data;
    data.editingItem = null;
    data.itemData = Vue.observable({ ...this.$store.getters[`${this.scope}/newItem`] });
    data.dialog = true;
  }

  addItemAndCloseDialog() {
    if (this.$data.editingItem !== null) {
      this.$store.commit(`${this.scope}/updateItem`,
        { id: this.$data.editingItem, data: this.$data.itemData });
    } else {
      this.$store.commit(`${this.scope}/addItem`, this.$data.itemData);
    }
    this.closeDialog();
  }

  editItem(item: any) {
    this.$data.editingItem = item.id;
    this.$data.itemData = Vue.observable({ ...item });
    this.$data.dialog = true;
  }

  deleteItem(item: any) {
    this.$store.commit(`${this.scope}/removeItem`, item.id);
  }
}
